import { render, staticRenderFns } from "./DockReceipt.vue?vue&type=template&id=534121e9&scoped=true"
import script from "./DockReceipt.vue?vue&type=script&lang=js"
export * from "./DockReceipt.vue?vue&type=script&lang=js"
import style0 from "./DockReceipt.vue?vue&type=style&index=0&id=534121e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534121e9",
  null
  
)

export default component.exports